/**
 * The fades at the plot's two ends that say "there is more this way".
 *
 * Shown only on a side the chart can still be scrolled to: the left one goes
 * when the oldest kept check is in view (a fade there would promise history
 * that was deleted), the right one when the chart follows now. They cover the
 * plot area, the lane and the time labels, never the y axis, whose numbers
 * are read at the left edge all the time. The card's own surface fades into
 * transparent, so the line looks like it runs on under the card's edge.
 *
 * They sit above the line and the lane (z 1) but under the plot's tooltip
 * (z 2, `ResponsePlot`), in the same box as both, so the pair keeps its order
 * whether that box is dimmed for loading (its own stacking context) or not.
 * Painted over the tooltip, the fade swallowed the time label of a hover
 * near the left edge and the figures of one flipped left near the right.
 */
import { FADE_WIDTH, PLOT_LEFT, PLOT_RIGHT } from "./layout";

function Fade({ side, on }: { side: "left" | "right"; on: boolean }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-y-0 z-[1] transition-opacity duration-200"
      style={{
        // The right one runs to the frame's edge over the plot's small right margin.
        [side]: side === "left" ? PLOT_LEFT : 0,
        width: side === "left" ? FADE_WIDTH : FADE_WIDTH + PLOT_RIGHT,
        opacity: on ? 1 : 0,
        background: `linear-gradient(to ${side === "left" ? "right" : "left"}, var(--crm-surface), transparent)`,
      }}
    />
  );
}

export function EdgeFade({ left, right }: { left: boolean; right: boolean }) {
  return (
    <>
      <Fade side="left" on={left} />
      <Fade side="right" on={right} />
    </>
  );
}
